import {
  TicketsView,
  TicketDetailView,
  TicketsListView,
  ApprovalsListView,
  RequestPendingListView,
  RegisteredRequest,
} from '@/views';
import { TYPE } from '@/store/modules/catalog';
import store from '@/store';
// import { NAMED_ROLES } from '@/store/modules/session';

const getPathName = (path = '') => (path.startsWith('/') ? path.split('/')[1] : path);

const getTicketTypeByPath = (path = '') => {
  const pathName = getPathName(path);

  switch (pathName) {
  case 'requests': return TYPE.REQUEST;
  case 'incidents': return TYPE.INCIDENT;
  case 'problems': return TYPE.PROBLEM;
  case 'approvals': return TYPE.REQUEST;

  default: throw new Error(`Unknown ticket type from ${pathName}`);
  }
};

// const hasRole = (role) => store.getters['session/hasRole'](role);

const camelize = (param) => (param ? param.replace(/-(\w)/ig, (repl) => repl.substring(repl.lastIndexOf('-') + 1).toUpperCase()) : undefined);

const parseQuery = function parseQuery(query, excludedKeys = []) {
  return Object.fromEntries(Object.entries(query)
    .filter((queryParam) => !excludedKeys.includes(queryParam))
    // replace '-' to camelcase
    .map((entry) => ([
      camelize(entry[0]),
      entry[1],
    ])));
};

const myRequestsRoutes = {
  publicPaths: [],
  privatePaths: [
    {
      path: '/requests',
      component: TicketsView,
      children: [
        {
          path: '',
          component: TicketsListView,
          name: 'TicketsListView',
          props: ({ query, path }) => {
            const { sort, asc } = query;
            const filters = parseQuery(query, ['sort', 'asc']);

            if (Object.keys(filters).length === 0) {
              filters.status = store.getters['session/user'].isUserTecnical
                ? ['OP', 'FIX', 'DEL', 'PL_ENT', 'PEND_APRO', 'PEND_PRES']
                : ['OP', 'FIX', 'DEL', 'PL_ENT', 'PEND_APRO'];
            }
            return {
              sort: sort || 'open_date',
              filters: Object(filters),
              asc: Boolean(asc) || false,
              goDetail: `/${getPathName(path)}`,
            };
          },
        },
        {
          path: ':idTicket',
          component: TicketDetailView,
          name: 'TicketDetailView',
          props: ({ path, query, params }) => {
            console.log('PROPS TicketDetailView', { path, query, params });
            const queryParams = parseQuery(query, ['action']);
            return {
              ticketType: getTicketTypeByPath(path),
              idTicket: params.idTicket,
              action: query.action ? camelize(query.action) : '',
              params: queryParams,
              isTIC: false,
            };
          },
        },
        {
          path: 'registered/:type/:idTicket/:name',
          component: RegisteredRequest,
          name: 'RegisteredRequest',
          props: ({ params }) => ({
            idTicket: params.idTicket,
            name: params.name || '',
            type: params.type,
            isTIC: false,
          }),
        },
      ],
    },
    {
      path: '/approvals',
      component: TicketsView,
      props: () => ({
        ticketType: 'R',
        listURL: '/approvals',
      }),

      children: [
        {
          path: '',
          component: ApprovalsListView,
          props: ({ query, path }) => {
            const filters = Object.fromEntries(Object.entries(query)
            // replace '-' to camelcase
              .map((entry) => ([
                entry[0].replace(/-(\w)/ig, (repl) => repl.substring(repl.lastIndexOf('-') + 1).toUpperCase()),
                entry[1],
              ])));
            return {
              filters: Object(filters),
              ticketType: 'R',
              goDetail: `/${getPathName(path)}`,
            };
          },
        },
        {
          path: ':idTicket',
          component: TicketDetailView,
          props: ({ query, params }) => {
            const queryParams = parseQuery(query, ['action']);
            return {
              ticketType: getTicketTypeByPath('requests'),
              idTicket: params.idTicket,
              action: query.action ? camelize(query.action) : '',
              params: queryParams,
              listURL: '/approvals',
            };
          },
        },
      ],
    },
    {
      path: '/pending',
      component: TicketsView,
      props: () => ({
        ticketType: 'R',
        listURL: '/pending',
      }),
      children: [
        {
          path: '',
          component: RequestPendingListView,
          props: ({ query, path }) => {
            const filters = Object.fromEntries(Object.entries(query)
            // replace '-' to camelcase
              .map((entry) => ([
                entry[0].replace(/-(\w)/ig, (repl) => repl.substring(repl.lastIndexOf('-') + 1).toUpperCase()),
                entry[1],
              ])));
            if (Object.keys(filters).length === 0) {
              filters.status = ['FIX', 'DEL', 'PEND_APRO'];
              filters.type = ['R', 'I', 'P'];
            }
            return {
              filters: Object(filters),
              goDetail: `/${getPathName(path)}`,
            };
          },
        },
        {
          path: ':idTicket',
          component: TicketDetailView,
          props: ({ query, params }) => {
            const queryParams = parseQuery(query, ['action']);
            return {
              ticketType: getTicketTypeByPath('requests'),
              idTicket: params.idTicket,
              action: query.action ? camelize(query.action) : '',
              params: queryParams,
              listURL: '/pending',
            };
          },
        },
      ],
    },
    {
      // IMPORTANTE: esta habilitado para el listado del buscador general de backbone
      // y las urls que venga en el correo
      // TODO: avanzar con el desarrollo para la busqueda general
      path: '/tickets',
      component: TicketsView,
      props: () => ({
        ticketType: 'R',
      }),
      children: [
        {
          path: ':idTicket',
          component: TicketDetailView,
          props: ({ query, params }) => {
            const queryParams = parseQuery(query, ['action']);
            return {
              ticketType: getTicketTypeByPath('requests'),
              idTicket: params.idTicket,
              action: query.action ? camelize(query.action) : '',
              params: queryParams,
              backButton: false,
            };
          },
        },
      ],
    },
  ],
};

export default myRequestsRoutes;
